export enum State {
    drenthe = 'Drenthe',
    flevoland = 'Flevoland',
    friesland = 'Friesland',
    gelderland = 'Gelderland',
    groningen = 'Groningen',
    limburg = 'Limburg',
    noordBrabant = 'Noord-Brabant',
    noordHolland = 'Noord-Holland',
    overijssel = 'Overijssel',
    utrecht = 'Utrecht',
    zeeland = 'Zeeland',
    zuidHolland = 'Zuid-Holland',
}
